module.exports = __webpack_public_path__ + "assets/media/1.95928f10.wav";